module.exports = __webpack_public_path__ + "171a0a2865147c61d5beec285c15f1b0.svg";